import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class AvaliacaoModel {

    opcao: Number
    comentario: String

    enviaAvaliacao(avaliacaoModel: AvaliacaoModel): Promise<PhicubeResponse> {
        return new GatewayService().requestPost('/api/avaliacao', avaliacaoModel)
    }
}